export default __webpack_public_path__ + "static/media/Audio-Number-11.de3a697c.m4a";